import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/supply')({
  component: SupplyLayout,
});

function SupplyLayout() {
  return <Outlet />;
}
